import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Shop from './pages/Shop'; // Import the new Shop page
import Contact from './pages/Contact';
import Checkout from './pages/Checkout';
import Blog from './pages/Blog';
import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/blog" element={<Blog />} />
        {/* You can add other routes here, for example for the blog */}
      </Routes>
    </Router>
  );
}

export default App;
